import { ReactElement } from 'react';

import { useCurrentSubscriptionQuery } from 'api';
import { DocumentCategories } from 'features/documentCategories';

import { PageW } from './styled';

export function ResourcesPage(): ReactElement {
  useCurrentSubscriptionQuery();

  return (
    <PageW>
      <DocumentCategories />
    </PageW>
  );
}
